import { render, staticRenderFns } from "./AddDebitorObjectDlg.vue?vue&type=template&id=72515392&"
import script from "./AddDebitorObjectDlg.vue?vue&type=script&lang=js&"
export * from "./AddDebitorObjectDlg.vue?vue&type=script&lang=js&"
import style0 from "./AddDebitorObjectDlg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports